import { render } from "./LiveUpdatePrompt.vue?vue&type=template&id=8abcb486&scoped=true"
import script from "./LiveUpdatePrompt.vue?vue&type=script&lang=js"
export * from "./LiveUpdatePrompt.vue?vue&type=script&lang=js"

import "./LiveUpdatePrompt.vue?vue&type=style&index=0&id=8abcb486&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8abcb486"]])

export default __exports__